<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-link</v-icon>
        <span class="m-l-5">URL</span>
      </div>
      <div>
        <v-icon small :disabled="!prompt.url" @click="playPrompt">
          {{ isPlaying ? 'fa-stop-circle' : 'fa-play-circle' }}
        </v-icon>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>
    <v-text-field
      v-model="prompt.url"
      class="top-5 no-drag"
      placeholder="URL to audio file"
      dense
      hide-details
    >
    </v-text-field>
    <v-textarea
      v-model="prompt.transcription"
      placeholder="Transcription"
      class="textarea-input m-t-15 no-drag"
      solo
      hide-details
      rows="2"
      row-height="20"
    ></v-textarea>

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" />
      Your browser does not support the audio element.
    </audio>
  </div>

  <!-- <div class="d-flex align-start">
    <v-icon small class="m-r-15 width20px">fa-link</v-icon>
    <div class="width100">
      <v-text-field
        v-model="prompt.url"
        class="top-5"
        placeholder="URL to audio file"
        dense
        hide-details
      >
      </v-text-field>
      <v-text-field
        v-model="prompt.transcription"
        class="m-t-10"
        placeholder="Transcription"
        dense
        hide-details
      >
      </v-text-field>
    </div>
    <v-icon
      small
      class="m-r-5 m-l-20"
      :disabled="!prompt.url"
      @click="playPrompt"
    >
      {{ isPlaying ? 'fa-stop-circle' : 'fa-play-circle' }}
    </v-icon>

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" />
      Your browser does not support the audio element.
    </audio>
  </div> -->
</template>

<script>
export default {
  name: 'PayloadUrl',
  props: {
    index: Number,
    prompt: Object
  },
  data() {
    return {
      previewVoice: '',
      isPlaying: false
    }
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlaying = true
    })
    this.$refs.myAudio.addEventListener('ended', () => {
      this.isPlaying = false
    })
  },
  methods: {
    async playPrompt() {
      try {
        if (!this.isPlaying) {
          this.previewVoice = this.prompt.url

          this.$refs.myAudio.load()

          setTimeout(() => {
            this.$refs.myAudio.play()
          }, 300)
        } else {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      } catch {}
    },
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.min-width-55 {
  min-width: 55%;
}

.width20px {
  min-width: 20px;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}
.voice-header {
  display: flex;
  justify-content: space-between;
}
</style>
